// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__3XGUh","footer":"ModalFilter_footer__1eoUM"};